module.exports = __webpack_public_path__ + "img/2.68ae0b21.png";